export enum SalesEnquiryStatus {
	Ongoing = 0,
	Won = 10,
	LostNoFeedback = 20,
	LostTooExpensive = 30,
	LostLeadTimeTooLong = 40,
	LostProjectCancelled = 50,
	LostResponseTooLate = 60,
	LostPreferredSupplierChosen = 70,
	LostCustMadeInhouse = 80,
	LostBplRegret = 90,
}